module.exports = __webpack_public_path__ + "img/ncu-logo2_inverted.af46fed3.png";